import dashboard from './dashboard';

const menuItems = (location) => {
  return {
    items: [dashboard(location)]
  };
};

export default menuItems;
